import { render, staticRenderFns } from "./PrintVesselInvoice.vue?vue&type=template&id=384f7a44&scoped=true"
import script from "./PrintVesselInvoice.vue?vue&type=script&lang=js"
export * from "./PrintVesselInvoice.vue?vue&type=script&lang=js"
import style0 from "./PrintVesselInvoice.vue?vue&type=style&index=0&id=384f7a44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384f7a44",
  null
  
)

export default component.exports